import { FormContent } from 'components/Forms/FormContent';

export const Footer = () => {
  return (
    <div className="footer-container">
      <div className="footer-content">
        <span className="h2-dtm">Share your story!</span>
        <span className="h4-text">
          If you think you have been duped by a PAC, let us know! Share the information you have and
          we will work together to fight scam PACs everywhere.
        </span>
        <FormContent
          form="submit-a-pac"
          containerId="footer-hubspot-form-container"
          className="full-width"
        />
      </div>
    </div>
  );
};
